<template>
 <svg
  :height="height"
  :width="width"
  :aria-labelledby="iconName"
  viewBox="0 0 1050 1050"
 >
  <path
    transform="scale(1,-1) translate(0,-950)"
    fill="white"
    stroke="none"
    stroke-width="1" d="M512 960c-282.77 0-512-229.23-512-512s229.23-512 512-512c282.77 0 512 229.23 512 512v0c0 282.77-229.23 512-512 512v0zM512 54.154c-217.86 0-394.471 176.611-394.471 394.471s176.611 394.471 394.471 394.471c217.86 0 394.471-176.611 394.471-394.471 0-0.22 0-0.44-0.001-0.659v0.034c-0.356-217.592-176.83-393.846-394.471-393.846 0 0 0 0-0.001 0v0zM562.637 510.515v115.028c25.991-3.664 47.077-21.412 55.49-45.155l0.149-0.481c4.384-12.321 15.387-21.228 28.62-22.495l0.137-0.011h62.515c0.232-0.009 0.505-0.015 0.779-0.015 11.394 0 20.63 9.236 20.63 20.63 0 0.887-0.056 1.76-0.164 2.617l0.011-0.102c-15.266 82.244-83.622 144.631-167.577 150.628l-0.589 0.034v52.513c-0.339 12.636-10.495 22.792-23.099 23.13l-0.032 0.001h-56.889c-12.636-0.339-22.792-10.495-23.13-23.099l-0.001-0.032v-52.513c-30.632 0-167.541-38.759-167.541-163.165 0-111.277 98.774-141.284 167.541-151.287v-125.031c-31.219 7.159-55.356 31.296-62.408 61.96l-0.107 0.555c-4.154 12.353-15.339 21.217-28.682 21.877l-0.075 0.003h-62.515c-0.453 0.038-0.981 0.059-1.514 0.059-10.703 0-19.38-8.677-19.38-19.38 0-1.125 0.096-2.227 0.28-3.3l-0.016 0.115c17.654-86.822 86.194-153.678 172.523-168.609l1.269-0.182v-53.763c0.339-12.636 10.495-22.792 23.099-23.13l0.032-0.001h58.139c12.503 0.349 22.505 10.567 22.505 23.122 0 0.003 0 0.006 0 0.009v0 52.513c95.676 5.068 172.473 79.491 181.237 173.658l0.057 0.76c1.25 111.902-96.274 143.785-181.294 152.537zM458.862 529.27c-91.272 0-91.272 78.769 0 95.023zM562.637 302.339c-4.717-1.505-10.417-2.814-16.263-3.676l-0.616-0.075v108.151c88.147-2.501 102.525-83.145 16.879-104.4z"
    />
</svg>
</template>

<style lang="scss">
  
</style>
<script>
  export default {
    name: "Money",
     props: {
    iconName: {
      type: String,
      default: 'money'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
  }
</script>